import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';


function GridCards({cards}) {
  return (
    <Row xs={1} md={2} className="g-4">
      {cards.map((card, idx) => (
        <Col>
          <Card>            
            <Card.Body>
              <Card.Title>{card.title}</Card.Title>
              <Card.Text>
               {card.summary}                
              </Card.Text>
              <Button  id={idx} variant="primary" href={card.url}>Go there</Button>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default GridCards;